import styled, { keyframes } from 'styled-components';

const gradient = keyframes`
    0% {background-position: 0%}
    100% {background-position: 100%}
`;

export const Loading = styled.div`
  height: 80px;
  width: 100%;
  padding: 4px;
  border-radius: 8px;
  background-size: 600% 100%;
  animation: ${gradient} 2s linear infinite;
  animation-direction: alternate-reverse;
  background-image: ${({ theme }) => theme.cardLoader.background};
`;

export const LoadingContainer = styled.div`
  margin-top: 8px;
  padding: 8px 16px;
  min-width: 100%;
`;
